import { React, useState, useEffect } from "react";
import { Input, DataListInput } from "./Input";
import { CustomDateField } from "../../../components/Form/FormComponents";
import FormAccordion from "../../../components/Form/FormAccordion";
import { ProductFormWrapper, ButtonGroup, Button, Formgroup } from "./ProductForm.styled";
import { InputData } from "./InputData";
import thrashIcon from "../../../assets/icons/trash.svg";
import saveIcon from "../../../assets/icons/Edit-Square.svg";
import { toast } from "react-toastify";
import { TextAreaField, CustomSelectField } from "../../lease/partials/FormComponents";
import {
	fetchAllCategories,
	fetchSubCategories,
	fetchBrands,
	fetchModels,
	formatTextField,
} from "../ProductUtils/CategoriesUtils";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import { useNavigate } from "react-router";
import { addProducts, formatInput, formatParseDate } from "../ProductUtils/utils";
import { getSessionToken } from "../../../utils/Utils";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";
import { shelfLife, MaintenanceScheduleOptions } from "../../../Constants";
import ConfirmModal from "../../../components/ConfirmModal";

/* eslint-disable react/prop-types */
function AddProductForm({
	parseFile,
	secondProductImage,
	thirdProductImage,
	setFirstImage,
	setSecondImage,
	setThirdImage,
}) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [allCategories, setAllCategories] = useState([]);
	// const [tags, setTags] = useState([]);
	const [subcategoryOptions, setSubcategoryOptions] = useState([]);
	const [brandOptions, setBrandOptions] = useState([]);
	const [modelOptions, setModelOptions] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [isMaintenance, setIsMaintenance] = useState(false); //state for tracking maintenance schedule
	const [ProductForm, SetProductForm] = useState({
		productName: "",
		shelfLife: "",
		category: "",
		subCategory: "",
		amount: "",
		brand: "",
		model: "",
		year: "",
		totalUnits: "",
		availableUnits: "",
		condition: "",
		color: "",
		description: "",
		keyFeatures: "",
		specifications: "",
		currentMileage: 0,
		lastMileage: 0,
		mileageVariance: 0,
		lastMaintenanceDate: "",
		maintenanceDuration: "",
		tags: [],
		pickupAddress: "",
	});

	useEffect(() => {
		fetchAllCategories()
			.then((categories) => {
				setAllCategories(categories);
			})
			.catch((error) => {
				console.log(error.message);
				toast.error("Unable to fetch categories data");
			});
	}, []);

	//track changes for mileage difference
	useEffect(() => {
		if (ProductForm?.lastMileage && ProductForm?.currentMileage) {
			const mileageDifference =
				parseInt(ProductForm?.currentMileage.replaceAll(",", "")) -
				parseInt(ProductForm?.lastMileage.replaceAll(",", ""));
			// console.log(mileageDifference);
			SetProductForm((prevData) => {
				return {
					...prevData,
					mileageVariance: mileageDifference,
				};
			});
			return;
		} else if (ProductForm?.lastMileage && !ProductForm?.currentMileage) {
			SetProductForm({ ...ProductForm, mileageVariance: 0 });
		}
	}, [ProductForm?.lastMileage, ProductForm?.currentMileage]);

	// console.log();

	//handle changes in input fields
	function handleChange(event) {
		const { name, value } = event.target;
		if (name === "lastMaintenanceDate") {
			SetProductForm((prevData) => {
				return {
					...prevData,
					[name]: { __type: "Date", iso: new Date(value + ":00Z").toISOString() },
				};
			});
			return;
		}
		SetProductForm((prevData) => {
			return {
				...prevData,
				[name]: value,
			};
		});
	}

	//post data products to parse server
	const saveProducts = async () => {
		let requiredFields;
		// console.log(ProductForm);
		if (isMaintenance) {
			requiredFields = [
				"productName",
				"shelfLife",
				"category",
				"subCategory",
				"amount",
				"brand",
				"model",
				"year",
				"totalUnits",
				"availableUnits",
				"condition",
				"color",
				"description",
				"keyFeatures",
				"specifications",
				"currentMileage",
				"lastMileage",
				// "mileageVariance",
				"lastMaintenanceDate",
				"maintenanceDuration",
				"pickupAddress",
			];
		} else {
			requiredFields = [
				"productName",
				"shelfLife",
				"category",
				"subCategory",
				"amount",
				"brand",
				"model",
				"year",
				"totalUnits",
				"availableUnits",
				"condition",
				"color",
				"description",
				"keyFeatures",
				"specifications",
			];
		}

		//check if any of the product field is empty, if yes return as an empty field
		const emptyFields = requiredFields.filter((field) => !ProductForm[field]);
		//all data must be filled and at least one image
		if (!parseFile["_url"] || emptyFields.length > 0) {
			// Handle validation error
			console.log(emptyFields.join(", "));
			toast.error(
				`Please ensure you fill the ${emptyFields.join(", ") || "image"} field(s) before clicking on save`
			);
			return;
		}
		dispatch(setLoadingState(true));
		// console.log(ProductForm);
		const formattedData = {
			category: ProductForm?.category,
			subCategory: ProductForm?.subCategory,
			productName: ProductForm?.productName,
			shelfLife: ProductForm?.shelfLife,
			amount: ProductForm?.amount?.replaceAll(",", ""),
			totalUnits: parseInt(ProductForm?.totalUnits),
			availableUnits: parseInt(ProductForm?.availableUnits),
			image: parseFile._url,
			secondImage: secondProductImage._url,
			thirdImage: thirdProductImage._url,
			color: ProductForm?.color,
			brand: ProductForm?.brand,
			model: ProductForm?.model,
			condition: ProductForm?.condition,
			year: ProductForm?.year,
			tags: [],
			lastMaintenanceDate: ProductForm?.lastMaintenanceDate
				? ProductForm?.lastMaintenanceDate
				: formatParseDate(new Date()),
			maintenanceDuration: ProductForm?.maintenanceDuration,
			lastMileage: ProductForm?.lastMileage
				? ProductForm?.lastMileage.replaceAll(",", "")
				: new Date().toISOString(),
			currentMileage: ProductForm?.currentMileage ? ProductForm?.currentMileage?.replaceAll(",", "") : "",
			mileageVariance: parseInt(ProductForm?.mileageVariance),
			description: formatTextField(ProductForm?.description),
			keyFeatures: formatTextField(ProductForm?.keyFeatures),
			specifications: formatTextField(ProductForm?.specifications),
			pickupAddress: ProductForm?.pickupAddress,
		};

		// console.log(formattedData);

		try {
			let data = await addProducts(formattedData, getSessionToken());
			if (data.result) {
				dispatch(setLoadingState(false));
				SetProductForm({});
				setFirstImage("");
				setSecondImage("");
				setThirdImage("");
				navigate("/products");

				toast.success("new product created, check products table to see updated list");
			} else {
				dispatch(setLoadingState(false));
				console.log(data);
				toast.error(data.error);
			}
		} catch (error) {
			dispatch(setLoadingState(false));
			toast.error("An error occured while creating the product");
		}
	};

	//handling of tags input
	// function handleKeyDown(e) {
	// 	if (e.key !== "Enter") return;
	// 	const value = e.target.value;
	// 	if (!value.trim()) return;
	// 	setTags([...tags, value]);
	// 	e.target.value = "";
	// }

	//remove tags
	// function RemoveTag(index) {
	// 	setTags(tags.filter((el, i) => i !== index));
	// }

	const getSubcategories = (e) => {
		const selectedCategory = e.target.value;
		if (selectedCategory === "Vehicles" || selectedCategory === "VEHICLE") {
			setIsMaintenance(true);
		} else {
			setIsMaintenance(false);
		}
		setBrandOptions([]);
		setModelOptions([]);
		// console.log(selectedCategory)
		fetchSubCategories(selectedCategory)
			.then((subcategories) => {
				//categories without sub categories
				if (subcategories[0].name === "") {
					toast.error("Sub categories not available");
					return;
				} else {
					setSubcategoryOptions(subcategories);
					SetProductForm({ ...ProductForm, category: selectedCategory }); //set value to form state
				}
			})
			.catch((error) => {
				console.log(error.message);
				toast.error("Unable to fetch subcategories data");
			});
	};

	const getBrands = (e) => {
		const index = e.target.selectedIndex;
		const selectedSubcat = subcategoryOptions[index - 1];
		//when you click on select
		if (!selectedSubcat) {
			console.log(selectedSubcat);
			SetProductForm({
				...ProductForm,
				subCategory: "",
				brand: "",
				model: "",
			});
			toast.error("brand not available for selected category");
			setModelOptions([]);
			setBrandOptions([]);
			return;
		}

		SetProductForm({
			...ProductForm,
			subCategory: selectedSubcat.name,
			brand: "",
			model: "",
		});
		setModelOptions([]);
		setBrandOptions([]);

		fetchBrands(selectedSubcat.id)
			.then((brands) => {
				if (brands.length <= 0) {
					SetProductForm({
						...ProductForm,
						subCategory: selectedSubcat.name,
						brand: "",
						model: "",
					});
					setModelOptions([]);
					setBrandOptions([]);
					toast.error("Brands not available");
					return;
				}
				//remove id, since it's only catId we need for models
				const modifiedBrands = brands.map(({ name, catId }) => ({
					name,
					id: catId,
				}));
				setBrandOptions(modifiedBrands);
				return;
			})
			.catch((error) => {
				setModelOptions([]);
				setBrandOptions([]);
				console.log(error.message);
				toast.error("brand not available for selected category");
			});
	};

	const getModels = (e) => {
		const index = e.target.selectedIndex;
		if (index === 0) {
			SetProductForm({ ...ProductForm, brand: "" });
			return;
		}
		const selectedBrand = brandOptions[index - 1]; //get index of selected option as all the options have the same id
		SetProductForm({ ...ProductForm, brand: selectedBrand.name, model: "" });
		fetchModels(selectedBrand.name, selectedBrand.id)
			.then((models) => {
				if (models[0].name === "") {
					toast.error("Model not available");
					setModelOptions([]);
					return;
				} else {
					setModelOptions(models);
				}
			})
			.catch((error) => {
				console.log(error.message);
				setModelOptions([]);
				toast.error("Unable to fetch list of models");
			});
	};

	const handleModel = (e) => {
		if (e.target.value === null) {
			return;
		}
		SetProductForm({ ...ProductForm, model: e.target.value });
	};

	const handleAmount = (e) => {
		const { name, value } = e.target;
		SetProductForm((prevData) => {
			return {
				...prevData,
				[name]: formatInput(value),
			};
		});
	};

	const handleYear = (date, dateString) => {
		SetProductForm((prevData) => {
			return {
				...prevData,
				year: dateString,
			};
		});
	};

	return (
		<FormAccordion title='Product Information' open={true}>
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: "Save Product",
						desc: "Are you sure you want to save this Product?",
						btnText: "Yes, Save",
					}}
					handleDeleteAction={saveProducts}
				/>
			)}

			<ProductFormWrapper>
				{InputData.map((item) => {
					if (item.name === "date") {
						return null; // Skip the item with name "date"
					} else if (item.name === "category") {
						return (
							<Formgroup key={item.id}>
								<label>CATEGORY</label>
								<CustomSelectField
									key={item.id}
									name={item.title}
									handleChange={getSubcategories}
									options={allCategories?.length > 0 ? allCategories : []}
									isEditable={true}
								/>
							</Formgroup>
						);
					} else if (item.name === "sub-category") {
						return (
							<Formgroup key={item.id}>
								<label>SUB-CATEGORY</label>
								<CustomSelectField
									key={item.id}
									name={item.title}
									options={subcategoryOptions}
									handleChange={getBrands}
									isEditable={true}
								/>
							</Formgroup>
						);
					} else if (item.name === "brand") {
						return (
							<Formgroup key={item.id}>
								<label>BRAND</label>
								<CustomSelectField
									key={item.id}
									name={item.title}
									options={brandOptions}
									isEditable={true}
									handleChange={getModels}
								/>
							</Formgroup>
						);
					} else if (item.name === "model") {
						return (
							<Formgroup key={item.id}>
								<label>MODEL</label>
								<CustomSelectField
									key={item.id}
									name={item.title}
									options={modelOptions}
									isEditable={true}
									handleChange={handleModel}
								/>
							</Formgroup>
						);
					}
					// else if (item.name === "tags") {
					// 	return (
					// 		<div className='input-tag-container' key={item.id}>
					// 			{tags.map((tag, index) => (
					// 				<div key={index} className='tag-item'>
					// 					<span>{tag}</span>
					// 					<span
					// 						onClick={() => {
					// 							RemoveTag(index);
					// 						}}
					// 						className='close'>
					// 						&times;
					// 					</span>
					// 				</div>
					// 			))}
					// 			<input
					// 				className='tag-input'
					// 				onKeyDown={handleKeyDown}
					// 				type={item.type}
					// 				name={item.name}
					// 				placeholder='Enter tags'
					// 			/>
					// 		</div>
					// 	);
					// }
					else if (item.name === "amount") {
						return (
							<Input
								key={item.id}
								value={ProductForm[item.name] || ""}
								title={item.title}
								handleChange={handleAmount}
								type={item.type}
								name={item.name}
							/>
						);
					} else if (item.name === "year") {
						return (
							<Formgroup key={item.id}>
								<label>YEAR</label>
								<DatePicker
									style={{ padding: "0.7rem", border: "1px solid #b8c8cf" }}
									onChange={handleYear}
									picker='year'
								/>
							</Formgroup>
						);
					} else if (item.name === "admin") {
						return null;
					} else if (item.name === "shelfLife") {
						return (
							<DataListInput
								key={item.id}
								title={item.title}
								name={item.name}
								options={shelfLife}
								handleChange={handleChange}
								value={ProductForm[item.name] || ""}
							/>
						);
					} else if (item.name === "pickupAddress") {
						return (
							<div style={{ gridColumn: "1/3" }} key={item.name}>
								<Input
									key={item.id}
									value={ProductForm[item.name] || ""}
									title={item.title}
									handleChange={handleChange}
									type={item.type}
									name={item.name}
								/>
							</div>
						);
					} else {
						return (
							<Input
								key={item.id}
								value={ProductForm[item.name] || ""}
								title={item.title}
								handleChange={handleChange}
								type={item.type}
								name={item.name}
							/>
						);
					}
				})}
			</ProductFormWrapper>

			{isMaintenance && (
				<FormAccordion title='Maintenance Schedule' open={true}>
					<div className='grid grid-cols-2 gap-3'>
						<Formgroup>
							<label>LAST MAINTENANCE DATE</label>
							<CustomDateField
								name='lastMaintenanceDate'
								value={ProductForm?.lastMaintenanceDate?.iso?.substring(0, 16) || ""}
								handleChange={handleChange}
								isEditable={true}
							/>
						</Formgroup>

						<DataListInput
							title={"MAINTENANCE DURATION"}
							name={"maintenanceDuration"}
							options={MaintenanceScheduleOptions}
							handleChange={handleChange}
							value={ProductForm?.maintenanceDuration || ""}
						/>

						<Input
							value={ProductForm?.lastMileage || ""}
							title={"LAST MILEAGE UPON MAINTENANCE( KM )"}
							handleChange={handleAmount}
							type={"text"}
							name={"lastMileage"}
						/>

						<Input
							value={ProductForm?.currentMileage || ""}
							title={"CURRENT MILEAGE(KM)"}
							handleChange={handleAmount}
							type={"text"}
							name={"currentMileage"}
						/>

						<Input
							value={ProductForm?.mileageVariance || ""}
							title={"MILEAGE VARIANCE(KM)"}
							type={"number"}
							name={"mileageVariance"}
							status={true}
						/>
					</div>
				</FormAccordion>
			)}

			<FormAccordion title='Product description' open={true}>
				<div className='form-group'>
					<TextAreaField
						name='description'
						handleChange={handleChange}
						isEditable={true}
						value={ProductForm.description}
					/>
				</div>
			</FormAccordion>

			<FormAccordion title='Key features'>
				<div className='form-group'>
					<TextAreaField
						name='keyFeatures'
						value={ProductForm.keyFeatures}
						handleChange={handleChange}
						isEditable={true}
					/>
				</div>
			</FormAccordion>

			<FormAccordion title='Product specifications'>
				<div className='form-group'>
					<TextAreaField
						name='specifications'
						value={ProductForm.specifications}
						handleChange={handleChange}
						isEditable={true}
					/>
				</div>
			</FormAccordion>

			<ButtonGroup>
				<Button type='button' color='#ffffff' onClick={() => setConfirmModal(true)} backgroundcolor='#003A50'>
					<img src={saveIcon} />
					<p>Save</p>
				</Button>

				<Link to={""}>
					<Button type='button' backgroundcolor='#FF7878' color='#ffffff'>
						<img src={thrashIcon} />
						<p>Cancel</p>
					</Button>
				</Link>
			</ButtonGroup>
		</FormAccordion>
	);
}

export default AddProductForm;
